<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="700px"
    custom-class="sysop-dialog"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="sd-head">
      <span class="sd-ico">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
      </span>
      <div class="sd-title">
        <span>{{ title }}</span>
        <span class="sd-pt">{{ titlePt }}</span>
      </div>
    </div>

    <div class="sd-body">
      <div class="alert alert-info">
        <svg
          class="ico"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
        <span class="alert-text">
          <span>
            系统配置由代码侧控制。点击"开始检索"会在仓库内搜索该州的 CTE/MDFE 开票主体代码配置，检索到则状态变更为<b class="ok">已配置</b>，未检索到则保持<b class="err">未配置</b>。
          </span>
          <span class="alert-pt">
            A configuração do sistema é controlada pelo código. Clique em "Iniciar Busca" para procurar no repositório a configuração de código da entidade emissora de CT-e/MDF-e deste estado; se encontrada, o status muda para <b class="ok">Configurado</b>; se não encontrada, permanece <b class="err">Não Configurado</b>.
          </span>
        </span>
      </div>

      <el-form :model="form" label-position="top" size="small">
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <bi-label zh="UF" pt="UF" inline />
              </template>
              <el-input v-model="form.uf" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <bi-label zh="公司名称" pt="Razão Social" inline />
              </template>
              <el-input v-model="form.companyName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <bi-label zh="CNPJ" pt="CNPJ" inline />
              </template>
              <el-input v-model="form.cnpj" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <bi-label zh="当前状态" pt="Status Atual" inline />
              </template>
              <div class="sd-status">
                <span class="tag" :class="tagCls">
                  <span class="dot" />{{ sysText }}
                  <span class="tag-pt">/ {{ sysTextPt }}</span>
                </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div v-if="result || searching" class="sd-result">
        <div v-if="searching" class="alert alert-info">
          <svg
            class="ico"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
          <span class="alert-text">
            <span>
              正在扫描代码库，匹配 <code>aujun-billing-config/{{ form.uf }}/issuer.json</code> 与 <code>CTEProviderConfig</code>…
            </span>
            <span class="alert-pt">
              Varrendo o repositório: <code>aujun-billing-config/{{ form.uf }}/issuer.json</code> e <code>CTEProviderConfig</code>…
            </span>
          </span>
        </div>
        <div v-else-if="result === 'ok'" class="alert alert-ok">
          <svg
            class="ico"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="m9 12 2 2 4-4" />
          </svg>
          <span class="alert-text">
            <span>
              检索成功：<b>{{ form.uf }}</b> 已在 <code>aujun-billing-config/{{ form.uf }}/</code> 找到开票主体配置，已更新为<b class="ok">已配置</b>。
            </span>
            <span class="alert-pt">
              Busca concluída: <b>{{ form.uf }}</b> encontrado em <code>aujun-billing-config/{{ form.uf }}/</code>; status atualizado para <b class="ok">Configurado</b>.
            </span>
          </span>
        </div>
        <div v-else class="alert alert-err">
          <svg
            class="ico"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 7.4v5.6" />
            <circle
              cx="12"
              cy="16.6"
              r="1.15"
              fill="currentColor"
              stroke="none"
            />
          </svg>
          <span class="alert-text">
            <span>
              未检索到 <b>{{ form.uf }}</b> 的开票主体代码配置。请先在仓库内创建
              <code>aujun-billing-config/{{ form.uf }}/issuer.json</code> 后重新检索。
            </span>
            <span class="alert-pt">
              Não encontrada a configuração de código de <b>{{ form.uf }}</b>. Crie
              <code>aujun-billing-config/{{ form.uf }}/issuer.json</code> no repositório e busque novamente.
            </span>
          </span>
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button size="small" @click="innerVisible = false">
        <bi-label zh="关闭" pt="Fechar" inline />
      </el-button>
      <el-button
        v-if="sysStatus === 1"
        size="small" type="warning"
        :loading="searching"
        @click="handleSearch(2)"
      >
        取消配置<span class="btn-pt"> / Cancelar configuração</span>
      </el-button>
      <el-button
        size="small" type="primary" :loading="searching"
        @click="handleSearch(1)"
      >
        {{ btnText }}<span class="btn-pt"> / {{ btnTextPt }}</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BiLabel from './BiLabel';
import { SYS_LABEL, fmtCnpj } from '../mock';
import { getInvoiceSubjectStatusMonitorIEUpdateSystemStatus } from '@/api/invoiceCenter';

export default {
  name: 'SysopDialog',
  components: { BiLabel },
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: null }
  },
  data() {
    return {
      form: { uf: '', companyName: '', cnpj: '' },
      searching: false,
      result: '', // '' | 'ok' | 'err'
      searched: false,
      localSysStatus: null
    };
  },
  computed: {
    /** 弹窗显隐：与父组件 visible 双向绑定（支持 v-model / .sync） */
    innerVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    },
    /** 当前州的系统配置状态（sysStatus：1已配置 2未配置），缺省视为未配置 */
    sysStatus() {
      return this.localSysStatus !== null ? this.localSysStatus : ((this.row && this.row.sysStatus) || 2);
    },
    /** 系统配置状态中文文案（已配置 / 未配置） */
    sysText() {
      return (SYS_LABEL[this.sysStatus] || {}).zh || '—';
    },
    /** 系统配置状态葡语文案 */
    sysTextPt() {
      return (SYS_LABEL[this.sysStatus] || {}).pt || '—';
    },
    /** 状态标签配色：已配置蓝 / 未配置红 */
    tagCls() {
      return this.sysStatus === 1 ? 'tag-info' : 'tag-err';
    },
    /** 弹窗标题（中文）：已配置的州提示可重新检索 */
    title() {
      return this.sysStatus === 1 ? '查看/重新检索代码配置' : '检索代码配置';
    },
    /** 弹窗标题（葡语） */
    titlePt() {
      return this.sysStatus === 1 ? 'Ver / Buscar Novamente a Config. de Código' : 'Buscar Config. de Código';
    },
    /** 检索按钮文案（中文）：检索中… / 再次检索 / 开始检索 */
    btnText() {
      if (this.searching) return '检索中…';
      if (this.searched) return '再次检索';
      return this.sysStatus === 1 ? '重新检索' : '开始检索';
    },
    /** 检索按钮文案（葡语） */
    btnTextPt() {
      if (this.searching) return 'Buscando…';
      if (this.searched) return 'Buscar Novamente';
      return this.sysStatus === 1 ? 'Buscar Novamente' : 'Iniciar Busca';
    }
  },
  watch: {
    /** 监听显隐：打开时回填当前行并重置检索状态（结果、loading 清空） */
    visible(v) {
      if (!v) return;
      const r = this.row || {};
      // CNPJ 按展示格式回填（00.000.000/0000-00）
      this.form = { uf: r.uf || '', companyName: r.companyName || '', cnpj: fmtCnpj(r.cnpj) || '' };
      this.searching = false;
      this.result = '';
      this.searched = false;
      this.localSysStatus = null;
    }
  },
  methods: {
    /** 模拟检索系统配置：1.1s 后按演示规则给出成功 / 失败，并通知父组件更新该州配置状态 */
    handleSearch(type) {
      if (this.searching || !this.row) return;
      this.searching = true;
      this.result = '';
      const param = {
        id: this.row.id,
        sysStatus: type
      };
      getInvoiceSubjectStatusMonitorIEUpdateSystemStatus(param).then(res => {
        if (res.code === 200) {
          this.searching = false;
          this.searched = true;
          this.localSysStatus = type;
          this.result = 'ok';
          this.$emit('updated');
        } else {
          this.searching = false;
          this.result = 'err';
        }
      }).catch(() => {
        this.searching = false;
        this.result = 'err';
      });
    }
  }
};
</script>

<style scoped lang="scss">
.sd-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}
.sd-ico {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #e6f0ff;
  color: #165dff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sd-title {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.sd-title .sd-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}

.alert {
  padding: 10px 14px;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
}
.alert-info {
  background: #e8f0fe;
  color: #165dff;
  border: 1px solid #c7dbff;
}
.alert-ok {
  background: #e8f7e9;
  color: #00b42a;
  border: 1px solid #c4e8d2;
}
.alert-err {
  background: #ffecec;
  color: #f53f3f;
  border: 1px solid #ffc9c9;
}
.alert .ico {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}
.alert-text {
  display: flex;
  flex-direction: column;
  line-height: 1.6;
}
.alert-text .alert-pt {
  font-size: 12px;
  color: #5c6b7a;
}
.alert-text code {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
  padding: 1px 4px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
.alert-text b.ok { color: #00b42a; }
.alert-text b.err { color: #f53f3f; }

.sd-status {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.sd-result {
  margin-top: 16px;
}
.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 18px;
  white-space: nowrap;
}
.tag .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.tag .tag-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}
.tag-info { background: #e6f0ff; color: #165dff; }
.tag-err { background: #ffecec; color: #f53f3f; }
.btn-pt {
  font-size: 12px;
}

::v-deep .sysop-dialog .el-dialog__header { display: none; }
::v-deep .sysop-dialog .el-dialog__body { padding: 20px; }
</style>
